<template>
  <div class="placeholder-glow">
    <div class="h3 mb-4"><span class="placeholder bg-secondary col-1"></span></div>
  </div>
  <div class="row">
    <div class="col-sm-6 col-lg-4">
      <div class="card-body p-0">
        <table class="table table-borderless table-sm placeholder-glow">
          <tbody>
          <tr>
            <td width="20%"><span class="placeholder bg-secondary col-8"></span></td>
            <td><span class="placeholder bg-secondary col-4"></span></td>
          </tr>
          <tr>
            <td><span class="placeholder bg-secondary col-8"></span></td>
            <td><span class="placeholder bg-secondary col-5"></span></td>
          </tr>
          <tr>
            <td><span class="placeholder bg-secondary col-10"></span></td>
            <td><span class="placeholder bg-secondary col-6"></span></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="placeholder-glow">
        <svg class="placeholder bg-secondary" width="100%" height="250" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect fill="grey" width="100%" height="100%" /></svg>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4 d-none d-md-block">
      <div class="card-body p-0">
        <table class="table table-borderless table-sm placeholder-glow">
          <tbody>
          <tr>
            <td width="20%"><span class="placeholder bg-secondary col-8"></span></td>
            <td><span class="placeholder bg-secondary col-4"></span></td>
          </tr>
          <tr>
            <td><span class="placeholder bg-secondary col-8"></span></td>
            <td><span class="placeholder bg-secondary col-5"></span></td>
          </tr>
          <tr>
            <td><span class="placeholder bg-secondary col-10"></span></td>
            <td><span class="placeholder bg-secondary col-6"></span></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="placeholder-glow">
        <svg class="placeholder bg-secondary" width="100%" height="250" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect fill="grey" width="100%" height="100%" /></svg>
      </div>
    </div>
    <div class="col-sm-6 col-lg-4 d-none d-lg-block">
      <div class="card-body p-0">
        <table class="table table-borderless table-sm placeholder-glow">
          <tbody>
          <tr>
            <td width="20%"><span class="placeholder bg-secondary col-8"></span></td>
            <td><span class="placeholder bg-secondary col-4"></span></td>
          </tr>
          <tr>
            <td><span class="placeholder bg-secondary col-8"></span></td>
            <td><span class="placeholder bg-secondary col-5"></span></td>
          </tr>
          <tr>
            <td><span class="placeholder bg-secondary col-10"></span></td>
            <td><span class="placeholder bg-secondary col-6"></span></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="placeholder-glow">
        <svg class="placeholder text-secondary" width="100%" height="250" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect fill="grey" width="100%" height="100%" /></svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
